import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CARD_TYPE, RESERVATION_STATUS } from './constants'

export { CARD_TYPE, RESERVATION_STATUS }

const CARD_TYPE_KEYS = {
  [CARD_TYPE.ACCES]: 'cartesAcces.common.cardType.acces',
  [CARD_TYPE.BIEN_ETRE]: 'cartesAcces.common.cardType.bienEtre',
}

const RESERVATION_STATUS_KEYS = {
  [RESERVATION_STATUS.PENDING]: 'cartesAcces.common.reservationStatus.pending',
  [RESERVATION_STATUS.CONFIRMED]: 'cartesAcces.common.reservationStatus.confirmed',
  [RESERVATION_STATUS.CANCELLED]: 'cartesAcces.common.reservationStatus.cancelled',
  [RESERVATION_STATUS.USED]: 'cartesAcces.common.reservationStatus.used',
}

const AMICAL_VALIDATION_KEYS = {
  pending: 'cartesAcces.common.amicalValidation.pending',
  validated: 'cartesAcces.common.amicalValidation.validated',
  rejected: 'cartesAcces.common.amicalValidation.rejected',
  cancelled: 'cartesAcces.common.amicalValidation.cancelled',
}

const SORT_VALUE_KEYS = {
  relevance: 'cartesAcces.common.sort.relevance',
  price_asc: 'cartesAcces.common.sort.priceAsc',
  price_desc: 'cartesAcces.common.sort.priceDesc',
  start_date: 'cartesAcces.common.sort.startDate',
}

const COUNTRY_CODES = ['TN', 'FR', 'MA', 'DZ', 'IT', 'ES']

export const useCartesAccesLabels = () => {
  const { t } = useTranslation()

  return useMemo(() => {
    const cardTypeLabel = (type) => t(CARD_TYPE_KEYS[type] || type)

    const cardTypeOptions = [
      { value: CARD_TYPE.ACCES, label: cardTypeLabel(CARD_TYPE.ACCES) },
      { value: CARD_TYPE.BIEN_ETRE, label: cardTypeLabel(CARD_TYPE.BIEN_ETRE) },
    ]

    const reservationStatusLabel = (status) =>
      t(RESERVATION_STATUS_KEYS[status] || status)

    const reservationStatusOptions = Object.keys(RESERVATION_STATUS_KEYS).map((value) => ({
      value,
      label: reservationStatusLabel(value),
    }))

    const amicalValidationLabel = (status) =>
      t(AMICAL_VALIDATION_KEYS[status] || status)

    const sortOptions = Object.entries(SORT_VALUE_KEYS).map(([value, key]) => ({
      value,
      label: t(key),
    }))

    const countryOptions = COUNTRY_CODES.map((code) => ({
      value: code,
      label: t(`cartesAcces.common.countries.${code}`),
    }))

    const formatCountry = (code) =>
      code ? t(`cartesAcces.common.countries.${code}`, { defaultValue: code }) : '—'

    return {
      t,
      cardTypeLabel,
      cardTypeOptions,
      reservationStatusLabel,
      reservationStatusOptions,
      amicalValidationLabel,
      sortOptions,
      countryOptions,
      formatCountry,
    }
  }, [t])
}

export {
  CARD_TYPE_KEYS,
  RESERVATION_STATUS_KEYS,
  AMICAL_VALIDATION_KEYS,
}
